export default {
    namespaced: true,

    state: () => ({
        id: 0,
        task_name: "", // 任务名称
        task_type: null, // 需求类型ID
        task_mode: null, // 交易模式，1-招募模式，2-竞单模式
        task_start_time: null, // 任务喀什时间，mode-1-报名截止时间，mode-2-交稿截止时间
        task_end_time: null, // 任务期望完成时间
        task_budget: null, // 任务预算
        task_description: "", // 任务描述
        task_files: [], // 任务文件列表
    }),

    mutations: {
        // 初始化数据
        INIT_STATE(state) {
            Object.assign(state, {
                id: 0,
                task_name: "",
                task_type: null,
                task_mode: null,
                task_start_time: null,
                task_end_time: null,
                task_budget: null,
                task_description: "",
                task_files: [],
            });

            console.log("init state: ", state);
        },

        // 设置数据
        SET_STATE(state, val) {
            Object.assign(state, val);
        },
    },

    actions: {},
};
